import { Parallax } from '../animations/parallax'

export function imageParallaxSection(element: HTMLElement) {
  const images = [...Array.from(element.querySelectorAll('.js-image'))] as HTMLElement[]

  function init(): void {
    Parallax(images[0], -0.05, 1)
    Parallax(images[1], -0.2, -1.75)
    Parallax(images[2], 0.5, 2.5)
  }

  function destroy(): void {
    // mm.revert()
    // gsap.set(image, { clearProps: 'all' })
    // timeline.kill()
    // if (trigger && trigger.scrollTrigger) {
    //   trigger.scrollTrigger.kill() // Kill the ScrollTrigger
    //   trigger = null
    //  }
  }

  // Return the init and destroy functions
  return {
    init,
    destroy
  }
}
